<template>
  <v-container class="w-auto mx-15" fluid>
    <v-row>
      <v-col>
        <DataTable
          class="elevation-0 w-100 gridTable"
          loading-text="Загрузка данных..."
          no-data-text="Нет данных"
          v-bind.sync="tableModel.bind"
          v-on="tableModel.on"
          :page.sync="tableModel.bind.options.page"
          hide-default-footer
        >
        <template v-slot:item.m.status="{ value }">
          <eventStatus
              :isSuccess="(value === mailStatus.SENT) ? true : ((value === mailStatus.FAILED) ? false : null)"
              :value="getStatusTextByCode(value)"
          />
        </template>

          <template v-slot:item.actions="{ item }">
            <v-dialog max-width="600">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn
                  class="px-0"
                  style="min-width: 35px;"
                  variant="text"
                  v-bind="activatorProps"
                >
                  <div style="max-width: 25px; max-height: 25px;">
                    <img src="../../../public/images/eye-outline.svg" style="width: 100%; height: 100%;">
                  </div>
                </v-btn>
              </template>

              <template v-slot:default="{ isActive }">
                <v-card>
                  <v-card-title
                    style="text-wrap: auto;"
                  >
                    {{ item.m.subject }}
                  </v-card-title>
                  <v-card-text
                    v-html="item.m.body"
                  />
                  <v-card-text v-if="isAdmin && item.m.attempts > 0">{{ $t('Количество попыток отправки сообщения: {_1}', { '_1': item.m.attempts }) }}</v-card-text>
                  <v-card-text v-if="isAdmin && item.m.lastError">{{ $t('Ошибка: {_1}', { '_1': item.m.lastError }) }}</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      :text="$t('Закрыть')"
                      @click="isActive.value = false"
                    ></v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
            <v-btn
              v-if="isAdmin && item.m.status === mailStatus.FAILED"
              class="px-0"
              style="min-width: 35px;"
              variant="text"
              @click="repeatSendMail(item)"
            >
              <div style="max-width: 25px; max-height: 25px;">
                <img src="../../../public/images/arrow_sending.svg" style="width: 100%; height: 100%;">
              </div>
            </v-btn>
          </template>

        </DataTable>
      </v-col>
    </v-row>
    <Pagination
      :page-sizes-list="pageSizesList"
      :table-model="tableModel"  
    />
  </v-container>
</template>
  
<script>
  import api from '@/api';
  import Config from "@/config";
  import { toast } from '@/lib/toast';
  import RemoteTableModel from '@/components/RemoteTableModel';
  import eventStatus from "@/components/eventStatus.vue";
  import { MailStatus, getMailStatusTextByCode } from "@/lib/mail";
  import Pagination from '@/components/Pagination.vue';
  import DataTable from '@intec/vue-components/table/DataTable.vue'

  export default {
    components: {eventStatus, Pagination, DataTable},
    data() {
      let currentUser = Config.getUser();
      const tableModel = new RemoteTableModel({
        headers: [
          { title: 'Дата отправки', key: 'm.createdAt', width: '15%' },
          { title: 'Тема', key: 'm.subject', width: '40%' },
          { title: 'Организация', key: 'c.fullName', width: '15%' },
          { title: 'Пользователь', key: 'u.fio', width: '15%' },
          { title: 'E-mail', key: 'm.email', width: '15%' },
          { title: 'Статус', key: 'm.status', width: '15%' },
          { title: '', key: 'actions', sortable: false, width: '10%' }
        ],
        loader(query) {
          const user = Config.getUser();
          if (!user.hasAccess('admin_notifications')) {
            return api.get(`/profile/mails`, { query: JSON.stringify(query) });
          } else {
            return api.get('/admin/administration/mails', { query: JSON.stringify(query) });
          }
        },
        options: {
          sortBy: [
            { key: 'm.createdAt', order: 'desc' }
          ],
          itemsPerPage: 10,
        },
      });
      return {
        tableModel: tableModel,
        KeysTableModel: tableModel.bind.headers.map(header => header.key),
        pageSizesList: [
          { title: '10', value: 10 },
          { title: '25', value: 25 },
          { title: '50', value: 50 },
          { title: '100', value: 100 },
        ],
        mailStatus: MailStatus,
        isAdmin: currentUser.hasRole('ROLE_ADMIN'),
      };
    },
    methods: {
      async repeatSendMail (item) {
        try {
          const response = await api.get('/profile/repeatSendMail', {mail_id: JSON.stringify(item.m.id)});
          this.tableModel.reload();
          toast.info(response);
        } catch (error) {
          toast.error(error);
        }
      },
      getStatusTextByCode(value) {
        return getMailStatusTextByCode(value);
      }
    },
  };
</script>